export const errorMessageDuplicateCommonCore: string =
	'Please check that the yarn.lock file contains only 1 version of proforma-common-core. ' +
	'You should bump all Proforma packages to their latest version';
